import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import KanbanBoard from '@/modules/tasks/taskboard/kanban/KanbanBoard';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import MainTask from './MainTask';
const OpenTask = ({ task, retrieveRemark, remark, loadingRemark }) => {
    const { setShowModalInfo } = useModalContext();
    const shareItem = (t) => {
        const parent = t.id === task.id ? undefined : task;
        setShowModalInfo({
            modalType: ModalType.Share,
            task: Object.assign(Object.assign({}, t), { relation: task.relation, parent }),
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx("td", Object.assign({ className: "dskb-cell dskb-header dskb-row-header dskb-group-container" }, { children: _jsx("div", Object.assign({ className: "dskb-content-box" }, { children: _jsx(MainTask, { task: task, shareItem: shareItem, openTaskDetails: () => {
                            setShowModalInfo({ modalType: ModalType.TaskDetail, task });
                        }, retrieveRemark: retrieveRemark, remark: remark, loadingRemark: loadingRemark }) })) })), _jsx(KanbanBoard, { task: task, shareItem: shareItem }, task.id)] }));
};
export default OpenTask;
